import { submitForm, deleteLiability } from './effects'
import isNumber from 'lodash/isNumber'

export const UPDATE_PROPS = 'UPDATE_PROPS'
export const GO_TO_ADD_LIABILITY = 'GO_TO_ADD_LIABILITY'
export const SET_LIABILITY_TYPE_TO_CREATE = 'SET_LIABILITY_TYPE_TO_CREATE'
export const SUBMIT_FORM = 'SUBMIT_FORM'
export const GO_TO_INDEX = 'GO_TO_INDEX'
export const BACK = 'BACK'
export const DELETE_LIABILITY = 'DELETE_LIABILITY'
export const UPDATE_LIABILITY = 'UPDATE_LIABILITY'
export const CONFIRM_DELETE = 'CONFIRM_DELETE'
export const LOADING = 'LOADING'

export const actionCreators = (dispatch, state) => ({
  updateProps: (props) =>
    dispatch({
      type: UPDATE_PROPS,
      payload: { props }
    }),
  goToAddLiability: () =>
    dispatch({
      type: GO_TO_ADD_LIABILITY
    }),
  goToIndex: () =>
    dispatch({
      type: GO_TO_INDEX
    }),
  back: () =>
    dispatch({
      type: BACK
    }),
  deleteLiability: (liabilityIndex) => () =>
    dispatch({
      type: isNumber(liabilityIndex) ? DELETE_LIABILITY : GO_TO_INDEX,
      payload: { liabilityIndex }
    }),
  updateLiability: (liabilityIndex) => () =>
    dispatch({
      type: UPDATE_LIABILITY,
      payload: { liabilityIndex }
    }),
  setLiabilityTypeToCreate: (liabilityType) => () =>
    dispatch({
      type: SET_LIABILITY_TYPE_TO_CREATE,
      payload: { liabilityType }
    }),

  // async actions
  submit: async (formValues) => {
    dispatch({
      type: LOADING
    })
    await submitForm(state, formValues)
    dispatch({
      type: SUBMIT_FORM
    })
  },
  confirmDelete: async () => {
    dispatch({
      type: LOADING
    })
    await deleteLiability(state)
    dispatch({
      type: CONFIRM_DELETE
    })
  }
})
